import { useTranslation } from 'react-i18next';
import MainTitle from '../common/MainTitle';

import ImageLink from '../../js/utils/ImageLink';

export default function HeroSection({ image1, title1, title2, description }) {
  const { t } = useTranslation(['CampusPage']);

  return (
    <section className="campus-hero-section container">
      {image1 && (
        <div className="campus-hero-section__secondary-media">
          <picture>
            <source srcSet={ImageLink(image1?.url)} type="image/webp" />
            <img src={ImageLink(image1?.url)} alt={image1?.alt} />
          </picture>
        </div>
      )}

      <div className="campus-hero-section__content">
        <MainTitle type="dark" className="text--2xl hidden--lg">
          <span>{title1 || t('campus')}</span>
          <span className="decorated-line decorated-line--dark decorated-line--left">
            {title2 || t('studentLife')}
          </span>
        </MainTitle>

        <div className="campus-hero-section__content-container">
          <MainTitle type="dark" className="text--2xl hidden--md">
            <span>{title1 || t('campus')}</span>
            <span className="decorated-line decorated-line--dark decorated-line--left">
              {title2 || t('studentLife')}
            </span>
          </MainTitle>

          <p>{t('heroSectionDescription')}</p>
        </div>
        {/* {image2 && (
          <div className="campus-hero-section__main-media">
            <picture>
              <source srcSet={ImageLink(image2?.url)} type="image/webp" />
              <img src={ImageLink(image2?.url)} alt={image2?.alt} />
            </picture>
          </div>
        )} */}
      </div>
    </section>
  );
}
